import styles from '../welcome/Welcome.module.scss';
import { Card } from 'components/uikit/Card';
import { Links } from '../../../application/constants/links.ts';
import { TypesOfCard } from '../welcome/Welcome.tsx';
import { QueryFactory } from '../../../services/api';
import { UserRole } from '../../../services/api/api-client.types.ts';

export const AdminPage = () => {
  const userQuery = QueryFactory.UserQuery.useGetCurrentUserInfoQuery();
  const userRoles = userQuery.data?.claimRoles ?? [];

  const isAdmin = userRoles.includes(UserRole.Admin);

  return (
    <>
      <div className={styles.welcomeContainer}>
        <div className={styles.rowContainer16}>
          {isAdmin && (
            <>
              <Card
                typeOfCard={TypesOfCard.SelfService}
                smallCard={true}
                links={[
                  {
                    name: 'abas_documents',
                    url: Links.Authorized.AbasDocuments.route,
                  },
                ]}
              />
              <Card
                typeOfCard={TypesOfCard.SelfService}
                smallCard={true}
                links={[
                  {
                    name: 'page_designer',
                    url: Links.Authorized.CustomPages.DesignerRoot.route,
                  },
                ]}
              />
            </>
          )}
          <Card
            typeOfCard={TypesOfCard.SelfService}
            smallCard={true}
            links={[
              {
                name: 'user_management',
                url: Links.Authorized.UserManagement.route,
              },
            ]}
          />
        </div>
      </div>
    </>
  );
};
